import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitsubject'
})
export class SplitsubjectPipe implements PipeTransform {

  transform(tag: string, lang: string): unknown {
    let subject = tag.split('-');

    if(lang=='fr') return subject[0];
    else if(lang=='ar') return subject[1];
  }

}
